import React from 'react';

const Features = () => {
  const features = [
    {
      icon: '📱',
      title: 'Works with Any Phone',
      description: 'No special apps needed. Customer just scans with phone camera.'
    },
    {
      icon: '⚡',
      title: '30 Second Setup',
      description: 'Connect your WhatsApp number and start collecting leads instantly.'
    },
    {
      icon: '💎',
      title: 'Premium Quality',
      description: '4"x6" acrylic stand + 3"x3" laminated vinyl stickers included.'
    },
    {
      icon: '♾️',
      title: 'Works Forever',
      description: 'One-time payment. No monthly subscription or hidden fees.'
    },
    {
      icon: '🛡️',
      title: 'Secure & Private',
      description: 'Your data stays with you. We don\'t store any customer information.'
    },
    {
      icon: '📞',
      title: '24/7 Support',
      description: 'Get help anytime with setup, customization or any questions.'
    },
    {
      icon: '🌐',
      title: 'Custom Messages',
      description: 'Pre-fill welcome messages or special offers automatically.'
    },
    {
      icon: '📈',
      title: 'Boost Revenue',
      description: 'Send targeted offers to increase customer lifetime value.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Everything You Need to Grow Your Business
          </h2>
          <p className="text-xl text-gray-600">
            Premium quality kit with powerful features
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:bg-green-50 transition-colors border border-gray-200">
              <div className="text-4xl mb-3">{feature.icon}</div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-br from-green-100 to-green-200 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">What's Included in Your Kit</h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h4 className="font-bold text-lg mb-3 text-green-600">🎯 Premium Acrylic QR Stand</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>High-quality 4"x6" acrylic material</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Professional design for counters & tables</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Durable & long-lasting</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Easy to clean & maintain</span>
                </li>
              </ul>
            </div>
            <div className="bg-white rounded-lg p-6 shadow-sm">
              <h4 className="font-bold text-lg mb-3 text-green-600">🎯 Vinyl QR Stickers Pack</h4>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Multiple 3"x3" laminated stickers</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Waterproof & weather resistant</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Place at entry, counter, or any surface</span>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-green-500 mt-1">✓</span>
                  <span>Strong adhesive backing</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;